import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./views/Dashboard.vue";
import Transaction from "./views/Transaction.vue";
import Payout from "./views/Payout.vue";
import Login from "./views/Login.vue";
import Home from "./views/Dashboard.vue";
import Profile from "./views/Profile.vue";
import Getstarted from "./views/Getstarted.vue";
import Help from "./views/HelpDesk.vue";

Vue.use(Router);

//This function authenticate every route to ensure users are logged in
let beforeEnter = (to, from, next) => {
  if (sessionStorage.getItem("vendor_id") == null) {
    next("login");
  } else {
    next();
  }
};
export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      beforeEnter
    },
    {
      path: "/",
      name: "Home",
      component: Home,
      beforeEnter
    },
    {
      path: "/profile-settings",
      name: "Profile",
      component: Profile,
      beforeEnter
    },
    {
      path: "/get-started",
      name: "Getstarted",
      component: Getstarted,
      beforeEnter
    },
    {
      path: "/collection",
      name: "Transaction",
      component: Transaction,
      beforeEnter
    },
    {
      path: "/settlement",
      name: "Payout",
      component: Payout,
      beforeEnter
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/help",
      name: "Help",
      component: Help,
      beforeEnter
    }
  ]
});
